angular.module('MyApp')
  .factory('Account', function($http) {
    return {
      getProfile: function() {
        return $http.get('/api/me');
      },
      updateProfile: function(profileData) {
        return $http.put('/api/me', profileData);
      },
      UpdateMDP: function(profileData) {
        return $http.put('/api/me', profileData);
      }
    };
  });